import * as TYPES from '../../types'

export default {
  [TYPES.SET_CURRENT_EVENT](state, event) {
    state.current = event
  },
}
